module.exports = __webpack_public_path__ + "static/img/ico_notice_mo.fdf2a87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010102/ico_notice_mo.png
// module id = GM+4
// module chunks = 10